import { AdminRolePayload } from "@bracket/idl/main/admin/model/AdminPt"

/** 로그인한 관리자 UI 모델 */
interface AdminAccount {
  id: string
  loginId: string
  name: string
  role: AdminRolePayload
  roleLabel: string
  isLocked: boolean
  lastLoginText: string
}

interface AdminLoginInput {
  loginId: string
  password: string
}

const ADMIN_ROLE_LABELS: Record<AdminRolePayload, string> = {
  [AdminRolePayload.ADMIN_ROLE_UNKNOWN]: "알 수 없음",
  [AdminRolePayload.ADMIN_ROLE_OPERATOR]: "운영자",
  [AdminRolePayload.ADMIN_ROLE_MASTER]: "마스터",
  [AdminRolePayload.UNRECOGNIZED]: "알 수 없음",
}

function adminRoleLabel(role: AdminRolePayload): string {
  return ADMIN_ROLE_LABELS[role] ?? "알 수 없음"
}

export { ADMIN_ROLE_LABELS, adminRoleLabel }
export type { AdminAccount, AdminLoginInput }
